import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'
import type { StoreBase } from '@/types'

import Head from 'next/head'
import { Fredoka, Geist_Mono, Plus_Jakarta_Sans } from 'next/font/google'
import { ToastProvider } from '@/components/generals/toast'
import { StoreShell } from '@/components/store/store-shell'

const sans = Plus_Jakarta_Sans({
    subsets: ['latin']
})

const heading = Fredoka({
    subsets: ['latin'],
    weight: ['500', '600', '700']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps, router }): ReactNode => {
    const isAdmin = router.pathname.startsWith('/admin')
    const store = (pageProps as { store?: StoreBase }).store ?? null

    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <ToastProvider>
                {isAdmin ? (
                    <Component {...pageProps} />
                ) : (
                    <StoreShell store={store}>
                        <Component {...pageProps} />
                    </StoreShell>
                )}
            </ToastProvider>
        </div>
    )
}

export default App
